import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import TestletStatus from "./TestletStatus";
import ReadingInfo from "./ReadingInfo";
import ReadingOverall from "../ReadingOverall";

@Component
export default class DashboardGeneral extends Vue {
  private overallData: any;
  private dbLayout: any;

  created() {
    this.dbLayout = this.getDashboardLayout();
    this.overallData = { skills: {}, testlets: {} };
  }

  private getDashboardLayout() {
    return this.$vuetify.breakpoint.lg
      ? [
          { x: 0, y: 7, w: 8, h: 9, i: "0" },
          { x: 8, y: 7, w: 4, h: 9, i: "1" },
          { x: 0, y: 0, w: 6, h: 7, i: "2" },
          { x: 6, y: 0, w: 6, h: 7, i: "3" }
        ]
      : [
          { x: 0, y: 27, w: 12, h: 9, i: "0" },
          { x: 0, y: 18, w: 12, h: 9, i: "1" },
          { x: 0, y: 0, w: 12, h: 9, i: "2" },
          { x: 0, y: 9, w: 12, h: 9, i: "3" }
        ];
  }

  private getAllData() {
    // if (this.overallData != {}) return true
    // overall data is the averages data.
    let averagesData = this.$store.getters.teacherDashboard.bala.timepoint1
      .averages;

    averagesData &&
      Object.keys(averagesData).forEach(key => {
        this.overallData["skills"][key] = averagesData[key];
        this.overallData["testlets"][key] = averagesData[key];
      });

    this.overallData["skills"].selection = "overall"; // selecting which overall dashboard;
    this.overallData["testlets"].selection = "overallTestlets"; // selecting which overall dashboard;

    // update dashboard layout if necessary
    this.dbLayout = this.getDashboardLayout();

    return true;
  }

  private dashboardUnavailable() {
    return (
      <v-container>
        <v-row>There's not enough data to generate a dashboard.</v-row>
      </v-container>
    );
  }

  private stateLoaded() {
    return (
      this.$store.getters.studentDataLoaded &&
      this.$store.getters.teacherDashboard.bala.timepoint1Loaded &&
      this.$store.getters.teacherDashboard.bala.descriptionsLoaded
    );
  }

  render(h: CreateElement) {
    return (
      (this.stateLoaded() && this.getAllData() && (
        <v-container>
          <grid-layout
            layout={this.dbLayout}
            col-num={12}
            row-height={30}
            is-draggable={false}
            is-resizable={false}
            is-mirrored={false}
            vertical-compact={false}
            margin={[24, 24]}
            use-css-transforms={false}
            ref="gridLayout"
          >
            <grid-item
              x={this.dbLayout[0].x}
              y={this.dbLayout[0].y}
              w={this.dbLayout[0].w}
              h={this.dbLayout[0].h}
              i={this.dbLayout[0].i}
              key={this.dbLayout[0].i}
            >
              <TestletStatus></TestletStatus>
            </grid-item>
            <grid-item
              x={this.dbLayout[1].x}
              y={this.dbLayout[1].y}
              w={this.dbLayout[1].w}
              h={this.dbLayout[1].h}
              i={this.dbLayout[1].i}
              key={this.dbLayout[1].i}
            >
              <ReadingInfo style={{ height: "inherit" }}></ReadingInfo>
            </grid-item>
            <grid-item
              x={this.dbLayout[2].x}
              y={this.dbLayout[2].y}
              w={this.dbLayout[2].w}
              h={this.dbLayout[2].h}
              i={this.dbLayout[2].i}
              key={this.dbLayout[2].i}
            >
              <ReadingOverall
                style={{ height: "inherit" }}
                data={this.overallData["skills"]}
              />
            </grid-item>
            <grid-item
              x={this.dbLayout[3].x}
              y={this.dbLayout[3].y}
              w={this.dbLayout[3].w}
              h={this.dbLayout[3].h}
              i={this.dbLayout[3].i}
              key={this.dbLayout[3].i}
            >
              <ReadingOverall
                style={{ height: "inherit" }}
                data={this.overallData["testlets"]}
              />
            </grid-item>
          </grid-layout>
          {/* <TestletStatus /> */}
        </v-container>
      )) ||
      this.dashboardUnavailable()
    );
  }
}

const component = DashboardGeneral;
